"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EquipListField = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireDefault(require("lodash.groupby"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _EquipPreview = require("./EquipPreview");

var _unassociate = require("../../../redux/modules/_BETA/unassociate");

var _utils = require("../../ActionModals/CreateAction/utils");

const RuleName = (0, _styledComponents.default)(_blocks.Body)`
  margin-bottom: ${_blocks.spacing.tight};
`;
const EquipList = _styledComponents.default.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: ${_blocks.spacing.default};
  padding-left: 0;
  /* This is an arbitrary padding number  */
  padding-right: 120px;

  &:last-of-type {
    margin-bottom: 0;
  }

  /* Targeting Chip preview trigger */
  > div {
    margin-right: ${_blocks.spacing.extraTight};
    margin-bottom: ${_blocks.spacing.extraTight};
  }
`;

function mapStateToProps(state) {
  return {
    unassociationComplete: state.betaUnassociate.complete,
    unassociationError: state.betaUnassociate.error
  };
}

function mapDispatchToProps(dispatch) {
  return {
    unassociateEquip: (syncoId, actionId) => {
      dispatch((0, _unassociate.unassociateEquipRule)({
        equipRuleIds: [syncoId],
        actionId
      }));
    }
  };
}

const EquipListField = ({
  actionId,
  equips,
  unassociateEquip,
  unassociationComplete,
  unassociationError
}) => {
  const [unassociatedEquipId, setUnassociatedEquipId] = _react.default.useState(undefined);

  const [associatedEquips, setAssociatedEquips] = _react.default.useState(equips); // Keep associated equips in sync with local state


  _react.default.useEffect(() => {
    setAssociatedEquips(equips);
  }, [equips]);

  const ruleGroups = (0, _lodash.default)(associatedEquips, e => e.ruleName);
  const sortedRuleGroups = Object.keys(ruleGroups).sort().reduce((finalGroup, key) => {
    finalGroup[key] = ruleGroups[key];
    return finalGroup;
  }, {});

  const unassociate = equipId => {
    if (equipId !== undefined) {
      unassociateEquip(equipId, actionId);
      setUnassociatedEquipId(equipId);
    }
  };

  _react.default.useEffect(() => {
    if (unassociationError === undefined && unassociationComplete && unassociatedEquipId !== undefined) {
      const updatedEquips = associatedEquips.filter(e => e.id !== unassociatedEquipId);
      setAssociatedEquips(updatedEquips);
    }
  }, [unassociatedEquipId, unassociationError, unassociationComplete]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Object.entries(sortedRuleGroups).map(([key, val]) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: key
  }, /*#__PURE__*/_react.default.createElement(RuleName, null, /*#__PURE__*/_react.default.createElement("strong", null, key)), /*#__PURE__*/_react.default.createElement(EquipList, null, (0, _utils.sortByEquipTargetName)(val).map(equip => /*#__PURE__*/_react.default.createElement(_EquipPreview.EquipPreview, {
    key: equip.occurrenceId,
    data: equip
  }, /*#__PURE__*/_react.default.createElement(_blocks.Chip, {
    type: "dismissable",
    onClick: () => unassociate(equip.id)
  }, equip.targetName)))))));
};

const Connected = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EquipListField);
exports.EquipListField = Connected;